import { useNavigate } from "react-router-dom";
import Modal from "../../../components/portal/Modal";
import successIcon from "../../../assets/icons/successIcon.svg";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";

const BulkSalarySuccessDialog = ({ viewDetails }) => {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content max-w-4xl">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Sheet Successfully Updated!</p>
      <div className="rounded-md 3xl border border-lg5 shadow-md mt-4 relative p-3">
        <div className="overflow-y-auto max-h-[50vh] border-1 border-lg5 border-t-0">
          <table className={`w-full text-center border-collapse`}>
            <thead
              className={`text-white text-xs lg:text-sm font-figtreeMedium bg-dark-blue sticky top-0 [&_th]:border [&_th]:border-gray-100`}
            >
              <th>User ID</th>
              <th>Name</th>
              <th>Previous Salary</th>
              <th>Updated Salary</th>
            </thead>
            <tbody>
              {viewDetails.map((item, ind) => {
                return (
                  <tr
                    key={ind}
                    className="text-xs lg:text-sm odd:bg-white even:bg-lg6 [&_td]:border [&_td]:border-gray-200"
                  >
                    <td>{item.user_id}</td>
                    <td>{item.name}</td>
                    <td>{item.previous_salary}</td>
                    <td>{item.updated_salary}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <table className="w-full mt-2">
          <tbody>
            <tr className="bg-lg6">
              <td className="p-2 border border-lg5 text-dark-blue font-figtreeMedium text-xs">
                Total Users Salary Updated : {viewDetails.length}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="md:mt-5 pt-3 text-center">
        <GradientButton
          btnText="Ok"
          width="28"
          onClick={() => navigate("/user/all")}
        />
      </div>
    </Modal>
  );
};

export default BulkSalarySuccessDialog;
